export default __webpack_public_path__ + "static/media/location-pin.7cb0b204.png";